// extracted by mini-css-extract-plugin
module.exports = {"closeBtn":"KjEk1ktrzN-B30X1TieEsQ==","closeIcon":"_7oLg0sJii-emMz0w9U+dQg==","item":"Hrvo2KxTdiU6IOacLCFtZw=="};